import { useTranslation } from 'react-i18next';
import { MainBreadcrumbs } from '../../Layout/MainBreadcrumbs';
import { MainLayout } from '../../Layout/MainLayout';
import { StandingOrderStepper, StandingOrderSteps } from './StandingOrderStepper';
import { Route } from '../../../routes/account.standing-orders_.$orderId_.$step';
import {
  useStandingOrderQuery,
  useUpdateStandingOrderMutation,
} from '../../../api/standing-orders';
import { StandingOrderStatusBadge } from './StandingOrderStatusBadge';
import { StandingOrderStatusActions } from './StandingOrderStatusActions';
import { useBoolean } from 'usehooks-ts';
import { notFound } from '@tanstack/react-router';
import { TerminateStandingOrderDialog } from './TerminateStandingOrderDialog';
import { StandingOrderOriginStep } from './StandingOrderOriginStep';
import { StandingOrderDestinationsStep } from './StandingOrderDestinationsStep';

export function EditStandingOrderPage() {
  const { orderId, activeStep } = Route.useParams({
    select: (params) => {
      const mappedStep = StandingOrderSteps[params.step as keyof typeof StandingOrderSteps];
      if (typeof mappedStep === 'undefined') throw notFound();
      return {
        orderId: params.orderId,
        activeStep: mappedStep,
      };
    },
  });
  const { t } = useTranslation();
  const deleteFlag = useBoolean(false);
  const orderQuery = useStandingOrderQuery({ orderId });

  const mutation = useUpdateStandingOrderMutation({ orderId });

  return (
    <MainLayout
      title={
        <MainBreadcrumbs
          title={t('Update standing order')}
          loading={orderQuery.isPending}
          action={
            orderQuery.isSuccess ? (
              <StandingOrderStatusBadge status={orderQuery.data.status} />
            ) : undefined
          }
          parent={{
            title: t('Standing orders'),
            to: '/account/standing-orders',
          }}
        />
      }
      actions={
        orderQuery.isSuccess ? (
          <StandingOrderStatusActions order={orderQuery.data} onTerminate={deleteFlag.setTrue} />
        ) : undefined
      }
    >
      {orderQuery.isSuccess ? (
        <>
          <StandingOrderStepper order={orderQuery.data} activeStep={activeStep} />
          {activeStep === StandingOrderSteps.origin ? (
            <StandingOrderOriginStep order={orderQuery.data} mutation={mutation} />
          ) : (
            <StandingOrderDestinationsStep order={orderQuery.data} />
          )}
          <TerminateStandingOrderDialog
            open={deleteFlag.value}
            onClose={deleteFlag.setFalse}
            order={orderQuery.data}
          />
        </>
      ) : null}
    </MainLayout>
  );
}
